export interface OnfleetTask {
  completionDetails: OnfleetCompletionDetails | null;
  destination: OnfleetDestination;
  id: string;
  metadata: OnfleetMetadata[];
  notes: string;
  pickupTask: boolean;
  recipients: OnfleetRecipient[];
  shortId: string;
  state: OnfleetTaskState;
  timeCreated: number;
  timeLastModified: number;
  trackingURL: string;
  worker: string | null;
}

export enum OnfleetTaskState {
  Unassigned = 0,
  Assigned = 1,
  Active = 2,
  Completed = 3,
}

export interface OnfleetCompletionDetails {
  notes?: string;
  photoUrl?: string;
  signatureUrl?: string;
  success: boolean;
  time: number;
}

export interface OnfleetDestination {
  address: {
    city?: string;
    country?: string;
    number?: string;
    postalCode?: string;
    state?: string;
    street?: string;
  };
  location: [number, number]; // [lng, lat]
}

export interface OnfleetRecipient {
  name: string;
  phone: string;
}

export interface OnfleetMetadata {
  name: string;
  type: string;
  value: boolean | number | string;
}
